import { Redirect, Route, type RouteProps } from 'react-router-dom'

import { user } from 'legacy/utils/user'

import { HashedUrl } from '../../../infra/HashedUrl'
import { stringifyQueryString } from '../../../infra/queryString'

export function PrivateRoute(props: RouteProps) {
  const isAuthorized = user.isLoggedIn() && user.get('type') === 'carrier'
  const currentUrl = HashedUrl.fromCurrentHref()

  if (!isAuthorized) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          search: stringifyQueryString({ href: currentUrl.pathname + currentUrl.search }),
        }}
      />
    )
  }

  return <Route {...props} />
}
